




















import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import Template from '@/models/template';
import TemplateSelection from '@/models/templateSelection';

@Component
export default class TemplateCard extends Vue {
  @Prop({ required: true }) private template!: Template;
  private depth!: number;

  @Emit('selected')
  private onClicked() {
    return new TemplateSelection(this.template, this.template.depths[this.depth]);
  }
}
